import React, {Component} from "react";
import Nav from '../../components/nav/Nav';
import {bindActionCreators} from "redux";

import {connect} from "react-redux";

import {
    Alert,
    Button,
    Pagination,
    PaginationItem,
    PaginationLink,
    Col,
    Row
} from 'reactstrap';

import {
    getCompletedChecklists
} from '../../actions/checklist';

import {
    getCompletedChecklists as getService,
} from '../../services/checklist';

import Spinner from '../../components/spinner/Spinner';
import env from "../../env";

class Completed  extends Component{

    constructor(){
        super();
        this.state = {
            loading: true,
            templates: {},
            users: {},
            checklists: {},
            error: null,
            template_id: '',
            user_id: '',
            search: '',
        };

    }

    componentWillReceiveProps(nextProps){

        const {completed} = nextProps.checklists;

        if (completed) {

            const {
                templates,
                users,
                checklists,
            } = completed.data || {};

            const error = completed.status ? null: completed.error? completed.error: 'Unable to get checklists, please try again later!';

            this.setState({
                error,
                templates,
                users,
                checklists,
                loading: false,
            });
        }

    }

    componentDidMount(){
        const {loggedIn} = this.props.account;

        if(!loggedIn){
            this.props.history.push(`${env.url}/login`);
        }

        this.fetch();

        this.initJQuery();
    }

    fetch = (query) => {

        const { site } = this.props.account;

        this.setState({
            loading: true,
        });

        if (site) {
            getService({id: site.id, query}).then((response) => {
                this.props.getCompletedChecklists(response);
            }).catch((error) => console.log(error));
        }
    };

    onChange = (event) => {
        let value = event.target.value;
        let name = event.target.name;

        this.setState({
            [name]: value,
        });
    };

    initJQuery(){

    }

    initSearch = (page = null) => {
        const {
            user_id,
            template_id,
            search,
        } = this.state;

        let current_page = page? page : 1;
        let query = '';

        if (current_page) {
            query = `?page=${current_page}`;
        }

        if (user_id) {
            query = query ? `${query}&checklist_user=${user_id}`: `?checklist_user=${user_id}`;
        }

        if (template_id) {
            query = query ? `${query}&checklist_template=${template_id}`: `?checklist_template=${template_id}`;
        }

        if (search) {
            query = query ? `${query}&search=${search}`: `?search=${search}`;
        }

        this.fetch(query);

        window.scrollTo(0, 0);
    };

    render(){

        const {
            checklists,
            loading,
            error,
            template_id,
            templates,
            user_id,
            users,
            search
        } = this.state;

        const {
            last_page,
            current_page,
            data,
        } = checklists || {};

        let pages = [];

        if(data){
            for(let i = 0; i < last_page; i++){
                pages.push(i+1);
            }
        }

        const bold = {
            fontFamily: 'PT Sans Narrow',
            fontWeight: '700',
            fontSize: '16px',
            lineHeight: '7px',
        };

        const { site } = this.props.account;

        return(
            <div className="checklists-completed-holder" style={{ margin: '30px 15px'}}>

                <Nav
                    location={this.props.location}
                    history={this.props.history}/>

                {
                    loading?
                        (
                            <Spinner/>

                        ):
                        (
                            error?
                                <Alert color="danger">{error}</Alert>
                                :
                                null
                        )

                }

                <div>
                    {
                        !loading?
                            <div>
                                <div style={{
                                    backgroundColor: '#fafafa',
                                    margin: '15px 0',
                                    padding: '10px',
                                }}>
                                    <Row>
                                        <Col>
                                            <div className="form-group">
                                                <label
                                                    htmlFor="template_id"
                                                    className="control-label">
                                                    Select Template
                                                </label>
                                                <select
                                                    value={template_id}
                                                    onChange={this.onChange}
                                                    className="selectpicker form-control"
                                                    id="template_id"
                                                    name="template_id">
                                                    <option value="">Select an option</option>
                                                    {
                                                        Object.keys(templates).map(key => <option key={key} value={key}>{templates[key]}</option>)
                                                    }
                                                </select>

                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="form-group">
                                                <label
                                                    htmlFor="user_id"
                                                    className="control-label">
                                                    Select User
                                                </label>
                                                <select
                                                    value={user_id}
                                                    onChange={this.onChange}
                                                    className="selectpicker form-control"
                                                    id="user_id"
                                                    name="user_id">
                                                    <option value="">Select an option</option>
                                                    {
                                                        Object.keys(users).map(key => <option key={key} value={key}>{users[key]}</option>)
                                                    }
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="form-group">
                                                <input
                                                    value={search}
                                                    onChange={this.onChange}
                                                    id="search"
                                                    className="form-control"
                                                    type="text"
                                                    name="search"
                                                    placeholder="Word search (e.g: Incident ID, Words in the note, Checklist name, etc...)"/>
                                            </div>
                                        </Col>
                                        <Col>
                                            <Button
                                                disabled={loading || !(search || user_id || template_id)}
                                                color="primary"
                                                onClick={()  => this.initSearch(null)}>
                                                Search
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>

                                {
                                    !loading && !data.length ?
                                        <div>
                                            <p style={{
                                                fontSize: '16px',
                                                textAlign: 'center',
                                                color: 'red',
                                                paddingTop: '15px',
                                            }}>No Checklists found!</p>
                                        </div>: null
                                }

                                <div>
                                    {
                                        data.map((checklist, key) => (
                                            <div key={key} style={{
                                                marginBottom: '15px',
                                                backgroundColor: '#fff',
                                                border: '1px solid #eaeaea',
                                                borderRadius: '4px',
                                                padding: '10px',
                                            }}>
                                                <div>
                                                    <span>Checklist: </span><strong style={bold}>{checklist.checklist_name}</strong>
                                                </div>
                                                {/*<div>*/}
                                                {/*    <span>Management Measure: </span><strong style={bold}>{checklist.aspect_name? checklist.aspect_name: 'N/A'}</strong>*/}
                                                {/*</div>*/}
                                                <div>
                                                    <span>Completed by: </span><strong style={bold}>{checklist.name}</strong>
                                                </div>
                                                <div>
                                                    <span>Completed on: </span><strong style={bold}> {checklist.date_completed.date ? checklist.date_completed.date.substr(0, 16): 'N/A'}</strong>
                                                </div>
                                                <div> <a href={`${env.base_url}mine/${site.id}/mobile-pdf?type=checklist&id=${checklist.completed_id}`} target="_blank">Click to View</a> </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>: null
                    }



                    {
                        !loading && last_page && last_page > 1?
                            (
                                <div style={{
                                    paddingBottom: '15px',
                                    height: '60px',
                                }}>
                                    <Pagination style={{float: 'right'}} aria-label="Risks navigation">
                                        <PaginationItem disabled={current_page === 1}>
                                            <PaginationLink onClick={() => this.initSearch(current_page - 1)} previous href="javascript:void(0)" />
                                        </PaginationItem>

                                        {
                                            pages.map(page => (
                                                <PaginationItem key={page} active={page === current_page}>
                                                    <PaginationLink onClick={() => this.initSearch(page)} href="javascript:void(0)">
                                                        {page}
                                                    </PaginationLink>
                                                </PaginationItem>
                                            ))
                                        }
                                        <PaginationItem disabled={current_page === last_page}>
                                            <PaginationLink onClick={() => this.initSearch(current_page + 1)} next href="javascript:void(0)" />
                                        </PaginationItem>

                                    </Pagination>
                                </div>
                            ):(<p/>)
                    }
                </div>
            </div>
        )
    }
}


const mapStateToProps = ({ account, checklists}) => ({
    account,
    checklists
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getCompletedChecklists : (response) => getCompletedChecklists(response),
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Completed)



// WEBPACK FOOTER //
// ./src/screens/checklists/Completed.js